module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/related/id_5-841d226e21d8400fe8b7afda1d9b825f.jpg";